import React, { useState } from 'react';
import { OtherAssetsEditForm } from '../EditAssetForm/components/OtherAssetsEditAssetForm/OtherAssetsEditAssetForm';
import {
  OtherAssetsAssetDTO,
  OtherAssetsSimulatedDTO,
} from '../../../../api/useEstatePlanningExplanationQuery';
import { EmptyState } from '../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { BeneficiariesData } from '../../useBeneficiaries';
import { OtherAsset } from './components/OtherAsset/OtherAsset';

interface Props {
  data: BeneficiariesData<OtherAssetsAssetDTO>[] | BeneficiariesData<OtherAssetsSimulatedDTO>[];
  isSimulation: boolean;
}

export const OtherAssets = ({ data, isSimulation }: Props) => {
  const [selectedAsset, setSelectedAsset] = useState<
    OtherAssetsAssetDTO | OtherAssetsSimulatedDTO | null
  >(null);

  if (data.length === 0) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <>
      {data.map(otherAsset => {
        return (
          <Box key={otherAsset.key} css="page-break-inside: avoid">
            <OtherAsset
              otherAsset={otherAsset}
              isSimulation={isSimulation}
              setSelectedAsset={setSelectedAsset}
            />
          </Box>
        );
      })}

      {selectedAsset && (
        <OtherAssetsEditForm
          asset={selectedAsset}
          onRequestClose={() => {
            setSelectedAsset(null);
          }}
          isSimulation={isSimulation}
        />
      )}
    </>
  );
};
